import { render, staticRenderFns } from "./CategoriesAdmin.vue?vue&type=template&id=2148adc6&"
import script from "./CategoriesAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoriesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports